import moment from 'moment';

export const lead0 = (n: number): string => {
    return n < 10 ? `0${n}` : `${n}`;
};

export const isIPad = (): boolean => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.userAgent?.isiPad || (isApple && navigator.maxTouchPoints > 1)
    );
};

const isApple = [
    'iPhone',
    'iPad',
    'iPod',
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
].includes(navigator.platform);

export const getDayWord = (date: string, elseFormat: string = 'dddd'): string => {
    const md = moment(date);
    const today = moment();

    if (md.isSame(today, 'date')) {
        return 'Today';
    }

    const tomorrow = moment().add(1, 'days');
    const yestarday = moment().add(-1, 'days');
    if (md.isSame(tomorrow, 'date')) {
        return 'Tomorrow';
    }
    if (md.isSame(yestarday, 'date')) {
        return 'Yesterday';
    }
    return md.format(elseFormat);
};

export const getPxPrintUrl = (pxId: string): string => {
    const fileName = `${pxId}-review-print`;
    return `/proxy/pdf/${fileName}`;
};

export const getOrdinalSufics = (count: number): string => {
    return {
        one: 'st',
        two: 'nd',
        few: 'rd',
        other: 'th',
        many: '',
        zero: '',
    }[
        new Intl.PluralRules('en-IN', {
            type: 'ordinal',
        }).select(count)
    ];
};

export function detectTouchscreen(): boolean {
    let result = false;
    if (window.PointerEvent && 'maxTouchPoints' in navigator) {
        // if Pointer Events are supported, just check maxTouchPoints
        if (navigator.maxTouchPoints > 0) {
            result = true;
        }
    } else {
        // no Pointer Events...
        if (window.matchMedia && window.matchMedia('(any-pointer:coarse)').matches) {
            // check for any-pointer:coarse which mostly means touchscreen
            result = true;
        } else if (window.TouchEvent || 'ontouchstart' in window) {
            // last resort - check for exposed touch events API / event handler
            result = true;
        }
    }
    return result;
}
